// extracted by mini-css-extract-plugin
export var actionText = "_ss-4";
export var container = "_ss-0";
export var leftSection = "_ss-1";
export var rightSection = "_ss-2";
export var settingsButton = "_ss-6";
export var settingsIcon = "_ss-7";
export var shortcut = "_ss-5";
export var shortcutGroup = "_ss-3";